<template>
  <div class="login">
    <container>
      <hgroup>
        <h1>Log ind</h1>
        <h3 class="color-tint">Udfyld felterne herunder</h3>
      </hgroup>
        <input-group label="Brugernavn">
          <input type="email" v-model="username" placeholder="E.g. john@doe.dk" spellcheck="false" v-on:keyup.enter="click" name="email" autocomplete="on">
        </input-group>
        <input-group label="Adgangskode">
          <input type="password" v-model="password" placeholder="Adgangskode" spellcheck="false" v-on:keyup.enter="click" name="password" autocomplete="on">
        </input-group>
      <button @click="click">Log ind</button>
    </container>
  </div>
</template>


<script>
import view from '../mixins/view'
import { isLoggedIn } from 'state/auth/getters'
import { login } from 'state/auth/actions'

import InputGroup from 'components/InputGroup.vue'

export default {
  name: 'ViewLogin',
  mixins: [view],
  components: {
    InputGroup
  },
  vuex: {
    getters: {
      isLoggedIn
    },
    actions: {
      login
    }
  },
  data () {
    return {
      username: null,
      password: null
    }
  },
  watch: {
    isLoggedIn () {
      if (this.isLoggedIn) {
        this.$router.go({name: 'root'})
      }
    }
  },
  methods: {
    click () {
      this.login(this.username, this.password)
    }
  },
  ready () {
    this.setTitle('Velkommen til Funktionel Hjernetræning')
  }
}
</script>


<style lang="scss" scoped>
.login {
  flex: 1;
  min-height: 100%;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// Login.vue?8f16a146